import { ReactNode } from 'react';

type MappingsReportCellPropsType = {
    children: ReactNode;
};
function MappingsReportCell({ children }: MappingsReportCellPropsType) {
    return <td>{children}</td>;
}

export default MappingsReportCell;
